/**
 * Created by swandelow on 9/2/16.
 */
angular.module('CarsSaraBo').factory('ItemSelectorService', function () {

    var ItemSelector = function (config, items, validations) {
        this.config = config;
        this.items = items;
        this.validations = validations;

        this.getSelectedItemsOid = function () {
            var selectedItems = [];
            for (oid in items) {
                if (items[oid].checked) {
                    selectedItems.push(oid);
                }
            }
            return selectedItems;
        }
    };

    var ItemSelectorBuilder = function () {
        var items = {};
        var config = {};
        var validations = {};

        return {
            items: function (anotherItems) {
                items = anotherItems;
                return this;
            },
            listOfItemsTitle: function (listOfItemsTitle) {
                config['listOfItemsTitle'] = listOfItemsTitle;
                return this;
            },
            listOfSelectedItemsTitle: function (listOfSelectedItemsTitle) {
                config['listOfSelectedItemsTitle'] = listOfSelectedItemsTitle;
                return this;
            },
            validations: function (anotherValidations) {
                validations = anotherValidations;
                return this;
            },
            build: function () {
                return new ItemSelector(config, items, validations);
            }
        }
    };

    return {

        newItemSelectorBuilder: function () {
            return new ItemSelectorBuilder();
        },

        getItemsForSelector: function (collection, selectedItems, nameGenerator) {
            var items = {};
            // create collection of items for the selector
            _.each(collection, function (obj) {
                var name = nameGenerator(obj);
                items[obj.oid] = {name: name};
            });
            // mark items as selected
            if (selectedItems) {
                _.each(selectedItems, function (selectedItemOid) {
                    if (items[selectedItemOid]) {
                        items[selectedItemOid].checked = true;
                    } else {
                        console.warn(selectedItemOid + ' is not present in items collection.');
                    }
                });
            }
            return items;
        }
    };

});



//////////////////
// WEBPACK FOOTER
// ./public/app/models/item_selector.js
// module id = 853
// module chunks = 3